<div *ngIf="!isSubmitted" class="modal-header d-flex align-items-center pt-0">
  <h4 *ngIf="title" class="modal-title" [ngClass]="classTitle">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x"
      viewBox="0 0 16 16">
      <path
        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
          2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  </button>
</div>
<div *ngIf="isBusy" class="col-12 text-center mb-4">
  <lib-loading
    [status]="'text-primary'" 
    [spinnerPosition]="true"
    [text]="'LDG'" 
    [size]="'md'">
  </lib-loading>
</div>
<div class="mx-4 mt-4" *ngIf="fb && fb.error">
  <lib-error [title]="getText()" [error]="fb.error"></lib-error>
</div>
<div *ngIf="!isSubmitted && !isBusy" class="modal-body" ngbAutofocus>
  <!-- <h1 *ngIf="h1">{{h1}}</h1>
  <h2 *ngIf="h2">{{h2}}</h2> -->
  <p *ngIf="body">{{ body }}</p>
  <div *ngIf="template">
    <ng-container *ngTemplateOutlet="template; context: { $implicit:test }">
    </ng-container>
  </div>
</div>
<div *ngIf="!isSubmitted && !isBusy" class="modal-footer">
  <div class="row mx-0 w-100 text-center text-sm-right">
    <div class="col-12 px-0 d-flex">
      <div class="col-6 pl-0 pr-2">
        <button type="button" (click)="confirmEmitter.emit(false)" class="btn btn-secondary slim-button w-100" data-dismiss="modal">
          {{ cancelButtonText }}
        </button>
      </div>
      <div class="col-6 pr-0 pl-2">
        <button type="button" [disabled]="isValid()" (click)="confirmYes()" class="btn slim-button w-100 {{ classButton }}">
          {{ saveButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="submit-container" *ngIf="isSubmitted">
  <div class="modal-header d-flex align-items-center">
    <button type="button" class="close" aria-label="Close" (click)="confirmEmitter.emit(false)">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x"
        viewBox="0 0 16 16">
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
            2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
      </svg>
    </button>
  </div>
  <div class="modal-body text-center pt-0">
    <div *ngIf="!templateSuccessMessage">
      <h4>{{ successMessage }}</h4>
    </div>
    <div *ngIf="templateSuccessMessage">
      <ng-container *ngTemplateOutlet="templateSuccessMessage;"></ng-container>
    </div>
  </div>
  <div class="modal-footer col-6 offset-3 pb-4">
    <button type="button" (click)="confirmEmitter.emit(false)" class="btn btn-secondary slim-button w-100">Ok</button>
  </div>
</div>
